import { createSlice } from '@reduxjs/toolkit';

const stylecollection = [
    {
        'theme': 'BASIC',
        'maincolor': '#93A5A1',
        'body': [
            { 'back': '#F8F8F8', 'color': '#000', 'accentback': '#D3E6E2', 'accentfore': '#000', 'require': 'rgba(248,149,91,0.1)' },
            { 'back': '#555D60', 'color': '#FFF', 'accentback': '#D3E6E2', 'accentfore': '#000', 'require': 'rgba(248,149,91,0.1)' },
            { 'back': '#697A76', 'color': '#FFF', 'accentback': '#D3E6E2', 'accentfore': '#000', 'require': 'rgba(248,149,91,0.1)' },
            { 'back': '#707782', 'color': '#FFF', 'accentback': '#D3E6E2', 'accentfore': '#000', 'require': 'rgba(248,149,91,0.1)' },
            { 'back': '#D3E6E2', 'color': '#93A5A1', 'accentback': '#D3E6E2', 'accentfore': '#000', 'require': 'rgba(248,149,91,0.1)' },
        ],
        'header': [
            { 'base': 'agex1_1', 'myfd': 'agmf1_1', 'back': '#93A5A1', 'color': '#FFFFFF' },
            { 'base': 'agex1_2', 'myfd': 'agmf1_2', 'back': '#D3E6E2', 'color': '#93A5A1' },
            { 'base': 'agex1_3', 'myfd': 'agmf1_3', 'back': '#697A76', 'color': '#D3E6E2' },
            { 'base': 'agex1_4', 'myfd': 'agmf1_4', 'back': '#7C766B', 'color': '#D3E6E2' },
            { 'base': 'agex1_5', 'myfd': 'agmf1_5', 'back': '#707782', 'color': '#D3E6E2' }
        ]
    },
    {
        'theme': 'PINK',
        'maincolor': '#D5A7B4',
        'body': [
            { 'back': '#F8F8F8', 'color': '#000', 'accentback': '#FFE3F0', 'accentfore': '#000', 'require':'rgba(213,167,180,0.2)' },
            { 'back': '#555D60', 'color': '#FFF', 'accentback': '#FFE3F0', 'accentfore': '#000', 'require': 'rgba(213,167,180,0.2)' },
            { 'back': '#B4AAD5', 'color': '#FFF', 'accentback': '#FFE3F0', 'accentfore': '#000', 'require': 'rgba(213,167,180,0.2)' },
            { 'back': '#F3C5D2', 'color': '#FFF', 'accentback': '#FFE3F0', 'accentfore': '#000', 'require': 'rgba(213,167,180,0.2)' },
            { 'back': '#FFE3F0', 'color': '#D5A7B4', 'accentback': '#FFE3F0', 'accentfore': '#000', 'require': 'rgba(213,168,180,0.2)' },
        ],
        'header': [
            { 'base': 'agex2_1', 'myfd': 'agmf2_1', 'back': '#D5A7B4', 'color': '#FFFFFF' },
            { 'base': 'agex2_2', 'myfd': 'agmf2_2', 'back': '#FFF7FF', 'color': '#D5A7B4' },
            { 'base': 'agex2_3', 'myfd': 'agmf2_3', 'back': '#794856', 'color': '#D5A7B4' },
            { 'base': 'agex2_4', 'myfd': 'agmf2_4', 'back': '#DEF3FF', 'color': '#D5A7B4' },
            { 'base': 'agex2_5', 'myfd': 'agmf2_5', 'back': '#706993', 'color': '#D5A7B4' },
            { 'base': 'agmf2_3', 'myfd': 'agex2_3', 'back': '#D5A7B4', 'color': '#794856' },
            { 'base': 'agmf2_4', 'myfd': 'agex2_4', 'back': '#D5A7B4', 'color': '#DEF3FF' },
            { 'base': 'agmf2_5', 'myfd': 'agex2_5', 'back': '#D5A7B4', 'color': '#706993' }
        ]
    },
    {
        'theme': 'BLUE',
        'maincolor': '#5482B6',
        'body': [
            { 'back': '#F8F8F8', 'color': '#000', 'accentback': '#BACDE1', 'accentfore': '#000', 'require': 'rgba(16,80,153,0.1)' },
            { 'back': '#555D60', 'color': '#FFF', 'accentback': '#BACDE1', 'accentfore': '#000', 'require': 'rgba(16,80,153,0.1)' },
            { 'back': '#5482B6', 'color': '#FFF', 'accentback': '#BACDE1', 'accentfore': '#000', 'require': 'rgba(16,80,153,0.1)' },
            { 'back': '#BACDE1', 'color': '#FFF', 'accentback': '#BACDE1', 'accentfore': '#000', 'require': 'rgba(16,80,153,0.1)' },
            { 'back': '#DCF0CF', 'color': '#105099', 'accentback': '#BACDE1', 'accentfore': '#000', 'require': 'rgba(16,80,153,0.1)' },
        ],
        'header': [
            { 'base': 'agex3_1', 'myfd': 'agmf3_1', 'back': '#105099', 'color': '#FFFFFF' },
            { 'base': 'agex3_2', 'myfd': 'agmf3_2', 'back': '#D8D4F2', 'color': '#105099' },
            { 'base': 'agex3_3', 'myfd': 'agmf3_3', 'back': '#FEFDC5', 'color': '#105099' },
            { 'base': 'agex3_4', 'myfd': 'agmf3_4', 'back': '#DCF0CF', 'color': '#105099' },
            { 'base': 'agex3_5', 'myfd': 'agmf3_5', 'back': '#FFE9F3', 'color': '#105099' },
            { 'base': 'agmf3_3', 'myfd': 'agex3_3', 'back': '#105099', 'color': '#FEFDC5' },
            { 'base': 'agmf3_4', 'myfd': 'agex3_4', 'back': '#105099', 'color': '#DCF0CF' },
            { 'base': 'agmf3_5', 'myfd': 'agex3_5', 'back': '#105099', 'color': '#FFE9F3' }
        ]
    },
    {
        'theme': 'LIME',
        'maincolor': '#9E9E40',
        'body': [
            { 'back': '#F8F8F8', 'color': '#000', 'accentback': '#D5D5B2', 'accentfore': '#000', 'require': 'rgba(158,158,77,0.1)' },
            { 'back': '#555D60', 'color': '#FFF', 'accentback': '#D5D5B2', 'accentfore': '#000', 'require': 'rgba(158,158,77,0.1)' },
            { 'back': '#ABAB66', 'color': '#FFF', 'accentback': '#D5D5B2', 'accentfore': '#000', 'require': 'rgba(158,158,77,0.1)' },
            { 'back': '#C7C799', 'color': '#FFF', 'accentback': '#D5D5B2', 'accentfore': '#000', 'require': 'rgba(158,158,77,0.1)' },
            { 'back': '#E3E3CC', 'color': '#9E9E4D', 'accentback': '#D5D5B2', 'accentfore': '#000', 'require': 'rgba(158,158,77,0.1)' },
        ],
        'header': [
            { 'base': 'agex4_1', 'myfd': 'agmf4_1', 'back': '#9E9E40', 'color': '#FFFFFF' },
            { 'base': 'agex4_2', 'myfd': 'agmf4_2', 'back': '#F5F2CB', 'color': '#9E9E40' },
            { 'base': 'agex4_3', 'myfd': 'agmf4_3', 'back': '#004E3F', 'color': '#9E9E40' },
            { 'base': 'agex4_4', 'myfd': 'agmf4_4', 'back': '#484387', 'color': '#9E9E40' },
            { 'base': 'agex4_5', 'myfd': 'agmf4_5', 'back': '#FFEBAE', 'color': '#9E9E40' },
            { 'base': 'agmf4_3', 'myfd': 'agex4_3', 'back': '#9E9E40', 'color': '#004E3F' },
            { 'base': 'agmf4_4', 'myfd': 'agex4_4', 'back': '#9E9E40', 'color': '#484387' },
            { 'base': 'agmf4_5', 'myfd': 'agex4_5', 'back': '#9E9E40', 'color': '#FFEBAE' }
        ]
    },
    {
        'theme': 'TAN',
        'maincolor': '#F89558',
        'body': [
            { 'back': '#F8F8F8', 'color': '#000', 'accentback': '#FCD1B8', 'accentfore': '#000', 'require': 'rgba(248,149,91,0.1)' },
            { 'back': '#555D60', 'color': '#FFF', 'accentback': '#FCD1B8', 'accentfore': '#000', 'require': 'rgba(248,149,91,0.1)' },
            { 'back': '#58356E', 'color': '#FFF', 'accentback': '#FCD1B8', 'accentfore': '#000', 'require': 'rgba(248,149,91,0.1)' },
            { 'back': '#F9A472', 'color': '#FFF', 'accentback': '#FCD1B8', 'accentfore': '#000', 'require': 'rgba(248,149,91,0.1)' },
            { 'back': '#FDE0D0', 'color': '#F8955B', 'accentback': '#FCD1B8', 'accentfore': '#000', 'require': 'rgba(248,149,91,0.1)' },
        ],
        'header': [
            { 'base': 'agex5_1', 'myfd': 'agmf5_1', 'back': '#F89558', 'color': '#FFFFFF' },
            { 'base': 'agex5_2', 'myfd': 'agmf5_2', 'back': '#FFD9C3', 'color': '#F89558' },
            { 'base': 'agex5_3', 'myfd': 'agmf5_3', 'back': '#58356E', 'color': '#F89558' },
            { 'base': 'agex5_4', 'myfd': 'agmf5_4', 'back': '#275336', 'color': '#F89558' },
            { 'base': 'agex5_5', 'myfd': 'agmf5_5', 'back': '#893232', 'color': '#F89558' },
            { 'base': 'agmf5_3', 'myfd': 'agex5_3', 'back': '#F89558', 'color': '#58356E' },
            { 'base': 'agmf5_4', 'myfd': 'agex5_4', 'back': '#F89558', 'color': '#275336' },
            { 'base': 'agmf5_5', 'myfd': 'agex5_5', 'back': '#F89558', 'color': '#893232' }
        ]
    },
    {
        'theme': 'SCARLET',
        'maincolor': '#C54126',
        'body': [
            { 'back': '#F8F8F8', 'color': '#000', 'accentback': '#E6ADA2', 'accentfore': '#000', 'require': 'rgba(197,65,38,0.1)' },
            { 'back': '#555D60', 'color': '#FFF', 'accentback': '#E6ADA2', 'accentfore': '#000', 'require': 'rgba(197,65,38,0.1)' },
            { 'back': '#B2D8F7', 'color': '#FFF', 'accentback': '#E6ADA2', 'accentfore': '#000', 'require': 'rgba(197,65,38,0.1)' },
            { 'back': '#D57764', 'color': '#FFF', 'accentback': '#E6ADA2', 'accentfore': '#000', 'require': 'rgba(197,65,38,0.1)' },
            { 'back': '#EEC8C1', 'color': '#C54126', 'accentback': '#E6ADA2', 'accentfore': '#000', 'require': 'rgba(197,65,38,0.1)' },
        ],
        'header': [
            { 'base': 'agex6_1', 'myfd': 'agmf6_1', 'back': '#C54126', 'color': '#FFFFFF' },
            { 'base': 'agex6_2', 'myfd': 'agmf6_2', 'back': '#EEC8C1', 'color': '#C54126' },
            { 'base': 'agex6_3', 'myfd': 'agmf6_3', 'back': '#B2D8F7', 'color': '#C54126' },
            { 'base': 'agex6_4', 'myfd': 'agmf6_4', 'back': '#FFC16A', 'color': '#C54126' },
            { 'base': 'agex6_5', 'myfd': 'agmf6_5', 'back': '#193F07', 'color': '#C54126' },
            { 'base': 'agmf6_3', 'myfd': 'agex6_3', 'back': '#C54126', 'color': '#B2D8F7' },
            { 'base': 'agmf6_4', 'myfd': 'agex6_4', 'back': '#C54126', 'color': '#FFC16A' },
            { 'base': 'agmf6_5', 'myfd': 'agex6_5', 'back': '#C54126', 'color': '#193F07' }
        ]
    },
    {
        'theme': 'SAFFRON',
        'maincolor': '#F4BF3C',
        'body': [
            { 'back': '#F8F8F8', 'color': '#000', 'accentback': '#F8D88A', 'accentfore': '#000', 'require': 'rgba(214,191,60,0.1)' },
            { 'back': '#555D60', 'color': '#FFF', 'accentback': '#F8D88A', 'accentfore': '#000', 'require': 'rgba(214,191,60,0.1)' },
            { 'back': '#C46D5E', 'color': '#FFF', 'accentback': '#F8D88A', 'accentfore': '#000', 'require': 'rgba(214,191,60,0.1)' },
            { 'back': '#F6CB63', 'color': '#FFF', 'accentback': '#F8D88A', 'accentfore': '#000', 'require': 'rgba(214,191,60,0.1)' },
            { 'back': '#F9DF9D', 'color': '#C46D5E', 'accentback': '#F8D88A', 'accentfore': '#000', 'require': 'rgba(214,191,60,0.1)' },
        ],
        'header': [
            { 'base': 'agex7_1', 'myfd': 'agmf7_1', 'back': '#F4BF3C', 'color': '#FFFFFF' },
            { 'base': 'agex7_2', 'myfd': 'agmf7_2', 'back': '#7D938A', 'color': '#F4BF3C' },
            { 'base': 'agex7_3', 'myfd': 'agmf7_3', 'back': '#C4605E', 'color': '#F4BF3C' },
            { 'base': 'agex7_4', 'myfd': 'agmf7_4', 'back': '#474973', 'color': '#F4BF3C' },
            { 'base': 'agex7_5', 'myfd': 'agmf7_5', 'back': '#286360', 'color': '#F4BF3C' },
            { 'base': 'agmf7_3', 'myfd': 'agex7_3', 'back': '#F4BF3C', 'color': '#C4605E' },
            { 'base': 'agmf7_4', 'myfd': 'agex7_4', 'back': '#F4BF3C', 'color': '#474973' },
            { 'base': 'agmf7_5', 'myfd': 'agex7_5', 'back': '#F4BF3C', 'color': '#286360' }
        ]
    },
];

const initialState = {
    stickys: [],
    stickycolor: [],
    stylecollection: stylecollection
};

const environSlice = createSlice({
    name: 'environ',
    initialState,
    reducers: {
        setstickys: (state, action) => {
            return Object.assign({}, state, { stickys: action.payload.stickys, stickycolor: action.payload.stickycolor})
        },
        resetenv: (state, action) => {
            return initialState;
        }
    },
});

export const {
    setstickys, resetenv
} = environSlice.actions

export default environSlice;

